{
  "general": {
    "copyright": "Laurent Chicoine Productions © 2022 All Rights Reserved.",
    "privacy": "Privacy Policy",
    "tos": "Terms of Service"
  },
  "form": {
    "blank": "[Blank]"
  },
  "user": {
    "displayName": "Name",
    "submit": "Save",
    "login-title": "Login",
    "register": "Register",
    "forgot-password": "Forgot Password",
    "email": "E-mail",
    "password": "Password",
    "password-again": "Confirm Password",
    "forgot-password-question": "Forget password?",
    "fullname": "Full Name",
    "login-button": "Login",
    "register-button": "Register",
    "reset-password-button": "Reset",
    "set-password-button": "Submit",
    "buy": "BUY",
    "username": "Username",
    "code": "Reset Code",
    "teams": "Teams",
    "add-new-user": "Add Member",
    "reset-password": "Reset Password",
    "set-password": "Set Password"
  },
  "configuration": {
    "cameras": "Cameras",
    "recordingSetups": "Recording Profiles",
    "integrationAccounts": "Integration Accounts",
    "recorders": "Recorders"
  },
  "recordingSetup": {
    "name": "Name",
    "active": "Active",
    "inactive": "Inactive",
    "status-filter-label": "Status",
    "camera": "Camera",
    "endzoneCamera": "Endzone Camera",
    "endzoneCamera2": "Endzone Camera 2",
    "detectionMode": "Detection Mode",
    "endzoneDetectionMode": "Endzone Detection Mode",
    "endzoneDetectionMode2": "Endzone Detection Mode 2",
    "submit": "Save",
    "detectionAreas": "Detection Areas",
    "mainAreas": "Main Areas",
    "endzoneMainAreas": "Endzone Main Areas",
    "endzoneMainAreas2": "Endzone Main Areas 2",
    "teams": "Available for Teams",
    "fixedTilt": "Fixed Tilt Configuration",
    "useFixedTilt": "Use Fixed Tilt",
    "fixedTiltMiddleAdjustment": "Fixed Tilt Adjusment to lower the viewing angle in the middle (in meters)",
    "fixedTiltEdgeAdjustment": "Fixed Tilt Adjusment to lower the viewing angle at the edges (in meters)",
    "lowQuality": "Data saver (lower quality)",
    "encodingCodec": "Encoding Codec",
    "saveOriginal": "Retrieve Original Videos",
    "includeScoreboard": "Show Scoreboard on Live Stream",
    "includeScoreboardInVideoTool": "Show Scoreboard in Video Tool"
  },
  "camera": {
    "name": "Name",
    "active": "Active",
    "inactive": "Inactive",
    "status-filter-label": "Status",
    "cameraModel": "Camera Model",
    "fieldType": "Field Type",
    "orientation": "Orientation",
    "scoreboardType": "Scoreboard Type",
    "fieldAnnotations": "Field Annotations",
    "rawAnnotations": "Raw Scoreboard Boundary",
    "scoreboardAnnotations": "Flattened Scoreboard Annotations",
    "detectionFieldAnnotations": "Detection Field Annotations",
    "snapshot": "Snapshot",
    "virtualCamera": "Virtual Camera Configuration",
    "virtualWidth": "Virtual Width",
    "virtualHeight": "Virtual Height",
    "panoFOV": "Panorama FOV (radian)",
    "verticalScale": "Vertical Scale",
    "rotationFormula": "Rotation Formula",
    "hasAudio": "Has audio",
    "audioHighPassFilter": "Audio High Pass Filter",
    "audioLowPassFilter": "Audio Low Pass Filter",
    "audioGain": "Audio Gain (db)",
    "usePCMAudio": "Uses PCM audio format",
    "useFilePacks": "Use file download",
    "minBitrate": "Minimum Bitrate",
    "maxBitrate": "Maximum Bitrate",
    "minFocal": "Minimum Focal",
    "camera": "Camera Configuration",
    "resolutionWidth": "Width",
    "resolutionHeight": "Height",
    "teams": "Available for Teams",
    "fps": "Frame Rate",
    "gop": "I Frame Interval",
    "rtspPort": "RTSP Port",
    "port": "HTTP Port",
    "channel": "Channel",
    "cameraMap": "Camera Map",
    "cameraMapMode": "Camera Map Mode",
    "multiband": "Multiband blending",
    "calibration": "Calibration (lens and rotation per sensor, JSON)",
    "calibrationInvalid": "The calibration is not a valid JSON object.",
    "calibrationRequired": "A parametric camera needs a calibration.",
    "calibrationNoSensors": "The calibration has no sensors: \"sensors\" must be a non-empty object.",
    "calibrationSensorNotObject": "Calibration sensor \"{{sensor}}\" must be an object.",
    "calibrationSensorInvalid": "Calibration sensor \"{{sensor}}\": \"{{field}}\" must be {{expected}}.",
    "calibrationOrderInvalid": "The calibration's \"order\" must be a list naming each sensor exactly once.",
    "calibrationExpectedPositivePair": "two numbers greater than 0",
    "calibrationExpectedPositive": "a number greater than 0",
    "calibrationExpectedNumber": "a number",
    "calibrationExpectedLens": "an object with f, k1, k2, k3, cx and cy",
    "calibrationExpectedRotation": "three numbers (Rodrigues vector)",
    "calibrationExpectedRect": "four numbers, or null",
    "calibrationExpectedModel": "one of angle, rectilinear, cylinder",
    "calibrationExpectedTrack": "an integer, 0 or greater",
    "rawSnapshotOf": "Raw snapshot {{index}} of {{count}} (left to right)",
    "scoreboardRawIndex": "Raw image holding the scoreboard",
    "sectionProjection": "Projection",
    "sectionMap": "Map",
    "sectionOutput": "Output",
    "fullCameraMap": "Full Camera Map",
    "ipAddress": "IP Address",
    "iperfIp": "IPerf IP Address",
    "rtspCacheName": "RTSP Cache Name",
    "ownerOrganization": "Owner Organization",
    "FOVRange": "Minimum/Maximum FOV (radian)",
    "panoWidth": "360 panorama width",
    "panoHeight": "180 panorama height",
    "panoXTranslation": "X map cutoff",
    "panoYTranslation": "Y map cutoff",
    "panoType": "Panorama projection",
    "detectionCamera": "Detection Camera Configuration",
    "recorder": "Recorder",
    "submit": "Save",
    "userName": "User",
    "userPassword": "Password",
    "ptzDataDelay": "Delay between record and PTZ (ms)",
    "ptzMode": "PTZ movement mode",
    "videoSaveDelay": "Delay between record and live RTSP (ms)",
    "applyPTZSlide": "Panorama is rotated 180°",
    "generateDetectionMap": "Generate Detection Map",
    "antiAliasRatio": "Anti-Aliasing Ratio",
    "start-ptz-calib": "Start PTZ Calibration",
    "start-focus-calib": "Start Focus Calibration"
  },
  "orientation":{
    "vertical": "Vertical",
    "horizontal": "Horizontal"
  },
  "scoreboard": {
    "scoreboard": "Scoreboard",
    "localScore": "Local Score",
    "awayScore": "Away Score",
    "gameClock": "Game Clock",
    "localScore1": "Local Score - Digit 1",
    "localScore2": "Local Score - Digit 2",
    "awayScore1": "Away Score - Digit 1",
    "awayScore2": "Away Score - Digit 2",
    "gameClock1": "Game Clock - Digit 1",
    "gameClock2": "Game Clock - Digit 2",
    "gameClock3": "Game Clock - Separator",
    "gameClock4": "Game Clock - Digit 3",
    "gameClock5": "Game Clock - Digit 4",
    "awayPenalty1Minutes": "Away Penalty 1 - Minutes",
    "awayPenalty1Seconds": "Away Penalty 1 - Seconds",
    "awayPenalty1Seconds1": "Away Penalty 1 - Seconds Digit 1",
    "awayPenalty1Seconds2": "Away Penalty 1 - Seconds Digit 2",
    "awayPenalty2Minutes": "Away Penalty 2 - Minutes",
    "awayPenalty2Seconds": "Away Penalty 2 - Seconds",
    "awayPenalty2Seconds1": "Away Penalty 2 - Seconds Digit 1",
    "awayPenalty2Seconds2": "Away Penalty 2 - Seconds Digit 2",
    "localPenalty1Minutes": "Local Penalty 1 - Minutes",
    "localPenalty1Seconds": "Local Penalty 1 - Seconds",
    "localPenalty1Seconds1": "Local Penalty 1 - Seconds Digit 1",
    "localPenalty1Seconds2": "Local Penalty 1 - Seconds Digit 2",
    "localPenalty2Minutes": "Local Penalty 2 - Minutes",
    "localPenalty2Seconds": "Local Penalty 2 - Seconds",
    "localPenalty2Seconds1": "Local Penalty 2 - Seconds Digit 1",
    "localPenalty2Seconds2": "Local Penalty 2 - Seconds Digit 2",
    "period": "Period",
    "down": "Down",
    "distance": "Distance",
    "yardLine": "Yard Line",
    "full": "Scoreboard area",
    "overrideLocalScore": "Override Local Score",
    "overrideAwayScore": "Override Away Score",
    "overridePeriod": "Override Period",
    "disableClock": "Disable Game Clock",
    "disableScoreboard": "Disable Scoreboard"
  },
  "integrationAccount": {
    "name": "Name",
    "type": "Type",
    "password": "Password",
    "email": "Email",
    "username": "Username",
    "submit": "Save",
    "authorization": "Authorization",
    "authorize": "Authorize",
    "revoke": "Revoke",
    "teams": "Available for Teams",
    "revoke-message-youtube": "Revoking the access will also remove all of the application's data associated with this YouTube account. Are you sure that you want to revoke the access?"
  },
  "team": {
    "name": "Name",
    "hockeyTVTeamId": "HockeyTV Team ID",
    "hudlTeamId": "Hudl Team ID",
    "vidswapTeamId": "VidSwap Team ID",
    "rseqTeamId": "RSEQ Team ID",
    "spordleId": "Spordle ID",
    "spordleUrl": "Spordle URL",
    "organization": "Organization",
    "scoreboardTemplate": "Scoreboard Template",
    "sport": "Sport",
    "level": "Category",
    "submit": "Save",
    "youtubeAccount": "YouTube Account",
    "hudlAccount": "Hudl Account",
    "vidswapAccount": "VidSwap Account",
    "videoTool": "Video Tool",
    "replayApiKey": "Replay API Key",
    "replayApiKeyHelp": "Enables Replay for this team. Games include a Replay event by default; other recordings can opt in.",
    "replayApiKeyPlaceholder": "Replay team API key",
    "internalVideoRetentionDays": "Internal video retention (days)",
    "internalVideoRetentionDaysHelp": "Internal recordings are automatically deleted this many days after their recording date. Only an administrator can change this value.",
    "iCalUrl": "Public ICal Link",
    "iCalLocations": "Select Locations with Auto-Recording",
    "gender": "Gender",
    "liveStreamPrefix": "Live Stream Title Prefix",
    "liveStreamThumbnail": "Live Stream Thumbnail (.png or .jpg 2MB max)",
    "isLocation": "Use as location (generic team)",
    "members": "Members with viewer access",
    "membersWrite": "Members with access to plan recording and edit team",
    "calendarSyncs": "Schedule Syncs",
    "defaultHudlShare": "Default Hudl Share",
    "liveStreamProvider": "Live Stream Provider",
    "get-video-sharing-link": "Copy Video Sharing Link"
  },
  "calendarSync": {
    "type": "Sync Type",
    "iCalUrl": "iCal URL",
    "location": "Location",
    "locationRequired": "Location is required for opponent scout sync",
    "opponentScout": "Opponent Scout (other games at home field)",
    "opponentScoutHint": "Syncs league games played at the location where the team is not involved, as Scout",
    "remove": "Remove",
    "startOffset": "Start Offset (minutes)",
    "endOffset": "End Offset (minutes)",
    "iCalRegexCaseInsensitive": "Case Insensitive",
    "iCalRegex": "Event Name Regex",
    "youtubePlaylist": "YouTube Playlist",
    "liveUnlistAfterEnd": "Unlist from YouTube after completion",
    "syncToVideoTool": "Sync to Video Tool",
    "syncToVideoToolType": "Games to Sync",
    "videoToolPrefix": "Prefix to add in video tool",
    "home-games": "Home",
    "all-games": "All"
  },
  "organization": {
    "name": "Name",
    "teamName": "Sport Teams Name",
    "mainColor": "Primary Team Color",
    "rseqOrganizationId": "RSEQ Institution ID",
    "spordleOfficeId": "Spordle Office ID",
    "language": "Language",
    "logo": "Logo",
    "replaceLogoColor": "Replace Logo Primary Color",
    "scoreboardName": "Name on Live Broadcast Scoreboard",
    "submit": "Save",
    "timezone": "Time zone",
    "enabled": "Enabled",
    "members": "Members",
    "admins": "Organization Administrators",
    "recordingSummaryRecipients": "Weekly Camera Usage Recipients"
  },
  "menu": {
    "app": "Home",
    "team": "Manage",
    "cameras": "Cameras",
    "recordingSetups": "Recording Profiles",
    "integrationAccounts": "Integration Accounts",
    "manage-team-members": "Manage Members",
    "manage-teams": "Manage Teams",
    "manage-organizations": "Manage Organizations",
    "manage-my-organization": "Manage My Organization",
    "manage-leagues": "Manage Leagues",
    "list": "List",
    "calendar": "Calendar",
    "configuration": "Configuration",
    "schedule": "Schedule",
    "login": "Login",
    "register": "Register",
    "forgot-password": "Forgot Password",
    "reset-password": "Reset Password",
    "error": "Error",
    "applications": "Applications",
    "about": "About",
    "confirmation": "Confirmation",
    "contact": "Contact",
    "docs": "Docs",
    "knowledge-base": "Knowledge Base",
    "sign-out": "Sign out",
    "impersonate": "Impersonate",
    "unimpersonate": "End impersonation",
    "recorders": "Recorders",
    "viewer": "Watch",
    "admin": "Administration",
    "tools": "System Tools"
  },
  "adminTools": {
    "run": "Run",
    "confirm-title": "Confirm",
    "succeeded": "Succeeded",
    "failed": "Failed",
    "restartJobManager": {
      "title": "Restart the job manager",
      "description": "Rebuilds the job manager's workers and counters from the database. Use it when completed jobs keep being retried or end up dead lettered while the workers are healthy.",
      "confirm": "Restart the job manager for the selected region? Jobs already assigned keep running.",
      "region": "Region",
      "all-regions": "All regions"
    }
  },
  "schedule": {
    "events": "Events",
    "state": "State",
    "recordings": "Recordings",
    "add-new-title": "Add New Recording",
    "sport": "Sport",
    "date": "Date",
    "start-time": "Start",
    "end-time": "End",
    "team": "Team",
    "recordingSetup": "Configuration",
    "hudlEvent": "Scheduled Event",
    "hudlCategory": "Category",
    "includeReplayEvent": "Make available in BoothPilot Replay",
    "hudlShare": "Share with",
    "liveBroadcast": "Broadcast live event",
    "liveBroadcastYoutube": "Broadcast live event to YouTube",
    "end": "End",
    "start": "Start",
    "eventName": "Event Name",
    "opponentTeam": "Opponent Team",
    "homeTeam": "Home Team",
    "videoPrivacy": "Visibility",
    "summary": "Summary",
    "details": "Details",
    "videos": "Videos",
    "cancel-confirm-message": "Are you sure you want to cancel this recording?",
    "end-confirm-message": "Are you sure you want to end this recording?",
    "end-recording": "End Now",
    "add-10-minutes": "Add 10 Minutes",
    "logs": "Logs",
    "recordingJobs": "Recording Jobs",
    "scoreboard": "Scoreboard",
    "rtmpBroadcastLink": "RTMP Link (with stream key)",
    "youtubeBroadcastKey": "YouTube Stream key (to broadcast to an existing event instead of creating one)",
    "vidswapType": "Type",
    "past-date-warning": "Selected date and time are in the past. The recording will use the backup on a best-effort basis; backups can cause glitches in the result.",
    "filter-mismatch": "This recording was just created but does not match your current filters.",
    "start-filter": {
      "7-days-ago": "Last 7 days",
      "today-only": "Today",
      "today-to-infinity": "Upcoming",
      "next-7-days": "Next 7 days"
    },
    "start-filter-label": "Date",
    "state-filter-label": "Exclude state",
    "privacy": {
      "public": "Public",
      "unlisted": "Unlisted",
      "private": "Private"
    },
    "endTimeRequired": "End time is required",
    "endTimeAfterStart": "End time must be after start time",
    "hudlEmptyWarning": "Video will not be uploaded to Hudl if left empty",
    "datepickerPlaceholder": "Datepicker"
  },
  "manage": {
    "users": "Users",
    "teams": "Teams",
    "organizations": "Organizations",
    "leagues": "Leagues"
  },
  "league": {
    "name": "Name",
    "enabled": "Enabled",
    "sport": "Sport",
    "level": "Category",
    "rseqLeagueId": "RSEQ League ID",
    "spordleId": "Spordle ID",
    "spordleOfficeId": "Spordle Office ID",
    "spordleUrl": "Spordle URL",
    "includePostSeason": "Include Post Season in Record",
    "timezone": "Time Zone",
    "submit": "Save",
    "gender": "Gender",
    "gameDuration": "Game Duration"
  },
  "impersonate":{
    "user": "User"
  },
  "state": {
    "recordings":{
      "submitted": "Submitted",
      "scheduled": "Scheduled",
      "recording": "Recording",
      "processing": "Processing",
      "completed": "Completed",
      "cancelled": "Cancelled",
      "error": "Error"
    }
  },
  "listAction":{
    "delete": "Delete",
    "cancel": "Cancel",
    "new": "ADD NEW",
    "loadPracticePlan": "LOAD PRACTICE PLAN"
  },
  "practicePlan":{
    "title": "Load Practice Plan",
    "untitledEvent": "Untitled",
    "untitledPractice": "Practice {{n}}",
    "commonAttributes": "Common attributes",
    "planSettings": "Plan settings",
    "file": "Practice plan file",
    "fileFormat": "PDF or Excel",
    "selectTeamFirst": "Select a team to enable upload.",
    "uploading": "Uploading…",
    "parsing": "Parsing…",
    "loadPlan": "Load plan",
    "bufferBefore": "Buffer before (min)",
    "bufferAfter": "Buffer after (min)",
    "categoriesIncluded": "Categories included",
    "categoriesHint": "Click to toggle. Excluded categories are removed immediately.",
    "practicesHeading": "Practices ({{count}}) — total recordings: {{total}}",
    "practiceNumberDate": "Practice {{n}} date",
    "practiceDateRequired": "Practice date is required",
    "removePractice": "Remove practice",
    "noRowsForPractice": "No rows for this practice. Click Add row below (practice date required).",
    "mergeWithNext": "Merge with next",
    "addRow": "Add row",
    "addPractice": "Add practice",
    "createRecording": "Create {{count}} recording",
    "createRecordings": "Create {{count}} recordings",
    "row": {
      "start": "Start",
      "end": "End",
      "configuration": "Configuration",
      "eventName": "Event name",
      "buffersLabel": "Buffer before / after (min)",
      "resetToDefault": "Reset to default",
      "remove": "Remove",
      "startRequired": "Start is required",
      "endRequired": "End is required",
      "endAfterStart": "End must be after Start",
      "configurationRequired": "Configuration is required",
      "eventNameRequired": "Event name is required"
    },
    "errors": {
      "selectTeamFirst": "Select a team before loading a plan.",
      "chooseFile": "Please choose a file first.",
      "failedToParse": "Failed to parse practice plan.",
      "pickPracticeDate": "Pick a practice date before adding rows.",
      "exceedsMax": "Plan exceeds max {{max}} events. Dropped — {{dropped}}. Filter categories to fit.",
      "reincludedDropped": "{{count}} re-included event(s) belonged to removed practices and were not restored. Re-load the plan to recover them.",
      "unsupportedFile": "Unsupported file type. Use PDF or Excel (xlsx).",
      "fileTooLarge": "File too large. Max {{mb}} MB.",
      "uploadFailed": "Upload failed ({{status}})",
      "teamRequired": "Team is required",
      "dedupedAtSubmit": "{{count}} event(s) ignored — same configuration and start/end as another event in this submission: {{names}}"
    }
  },
  "setupPreview": {
    "toggle": "Preview",
    "show": "Show configuration preview",
    "hide": "Hide configuration preview",
    "selectConfiguration": "Select a configuration to see its preview.",
    "loading": "Loading preview…",
    "unavailable": "No preview available for this configuration.",
    "noImage": "preview unavailable"
  },
  "pages": {
    "add-new": "ADD NEW",
    "add-new-modal-title": "Add New Item",
    "display-options": "Display Options",
    "orderby": "Order By : ",
    "product-name": "Product Name",
    "category": "Category",
    "description": "Description",
    "status": "Status",
    "cancel": "Cancel",
    "submit": "Submit",
    "delete": "Delete",
    "move": "Move",
    "action": "Action",
    "another-action": "Another action",
    "actions": "ACTIONS",
    "header": "Header",
    "details": "DETAILS",
    "orders": "ORDERS",
    "rating": "Rating",
    "price": "Price",
    "is-vegan": "Is Vegan",
    "order-status": "Order Status",
    "bake-progress": "Bake Progress",
    "popularity": "Popularity",
    "comments": "Comments",
    "error-title": "Ooops... looks like an error occurred!",
    "error-code": "Error code",
    "go-back-home": "GO BACK HOME",
    "no-access-title": "You don't have access to this application",
    "no-access-message": "Your account is not associated with any team in this application. Contact your administrator if you believe this is an error.",
    "signed-out-title": "You have been signed out",
    "signed-out-message": "You can sign back in at any time, or return to the home page.",
    "signed-out-sign-in": "Sign back in",
    "invoice-info": "Invoice template has an inline styled version for usage outside of the project as well as Angular version.",
    "angular-version": "Angular Version",
    "inline-version": "Inline Styled Html Version",
    "mailing-info": "Mailing templates use inline styling and table layout to be displayed well at various service providers. To provide better usability we include it as regular html with dangerouslySetInnerHTML.",
    "like": "Like",
    "likes": "Likes",
    "details-title": "Details",
    "comments-title": "Comments",
    "questions-title": "Questions",
    "similar-projects": "Similar Projects",
    "send": "Send",
    "addComment": "Add a comment",
    "location": "Location",
    "contact": "Contact",
    "responsibilities": "Responsibilities",
    "photos": "Photos",
    "who-to-follow": "Who to Follow",
    "follow": "FOLLOW",
    "followers": "FOLLOWERS",
    "recent-posts": "Recent Posts",
    "profile": "PROFILE",
    "friends": "FRIENDS",
    "images": "IMAGES",
    "purchase": "PURCHASE",
    "view-all": "View All",
    "prices":{
      "developer": "DEVELOPER",
      "team": "TEAM",
      "enterprise": "ENTERPRISE",
      "twofactorauthentication": "Two factor authentication",
      "teampermissions": "Team permissions",
      "245Support": "24/5 Support",
      "247Support": "24/7 Support",
      "useractionsauditlog": "User actions audit log",
      "featurecomparison" : "Feature Comparison",
      "pricecomparison" : "Price Comparison"
    }
  },
  "alert": {
    "success": "Success",
    "warning": "Warning",
    "error": "Error",
    "configurationSaveSuccessful": "Configuration saved successfully",
    "configurationSaveUnsuccessful": "An error occured while saving the configuration, please retry later",
    "tokenRevokeUnsuccessful": "An error occured during token revokation. Token might have already been revoked. Review your account permission to manually revoke the token https://myaccount.google.com/permissions",
    "teamSaveSuccessful": "Team saved successfully",
    "teamSaveUnsuccessful": "An error occured while saving the team, please retry later",
    "organizationSaveSuccessful": "Organization saved successfully",
    "organizationSaveUnsuccessful": "An error occured while saving the organization, please retry later",
    "leagueSaveSuccessful": "League saved successfully",
    "leagueSaveUnsuccessful": "An error occured while saving the league, please retry later",
    "recordingSaveSuccessful": "Recording updated successfully",
    "recordingSaveUnsuccessful": "An error occured while updating the recording, please try again later",
    "scoreboardSaveSuccessful": "Scoreboard updated successfully",
    "scoreboardSaveUnsuccessful": "An error occured while updating the scoreboard, please try again later",
    "addUserToOrganizationFailed": "An error occured while adding the member to your organization, please try again later",
    "ptzCalibStarted": "PTZ calibration queued",
    "focusCalibStarted": "Focus calibration queued",
    "copiedToClipboard": "Copied to clipboard"
  },
  "notifications":{
    "no-notification": "You have no recent notification"
  },
  "time-ago":{
    "a-few-seconds": "a few seconds ago",
    "a-minute-ago": "a minute ago",
    "minutes-ago": "{{minutes}} minutes ago",
    "an-hour-ago": "an hour ago",
    "hours-ago": "{{hours}} hours ago",
    "a-day-ago": "a day ago",
    "days-ago": "{{days}} days ago",
    "a-month-ago": "a month ago",
    "months-ago": "{{months}} months ago",
    "a-year-ago": "a year ago",
    "years-ago": "{{years}} years ago"
  },
  "jumbotron": {
    "hello-world": "Hello, world!",
    "lead": "This is a simple hero unit, a simple jumbotron-style component for calling extra attention to featured content or information.",
    "lead-detail": "It uses utility classes for typography and spacing to space content out within the larger container.",
    "learn-more": "Learn more"
  },
  "modal": {
    "close": "Close",
    "confirm-message": "Do you want to confirm?",
    "yes": "Yes",
    "no": "No",
    "cancel": "Cancel",
    "submit": "Submit",
    "add": "Add"
  },
  "privacyOptions": {
    "public": "Public",
    "private": "Private",
    "unlisted": "Unlisted"
  },
  "recorder":{
    "active": "Active",
    "name": "Name",
    "publicSSHKey": "Public SSH Key",
    "status": "Status",
    "remoteSSHPort": "Remote SSH Port",
    "outboundSSHPort": "Outbound SSH Port",
    "submit": "Save",
    "start-ssh": "Start SSH Session",
    "stop-ssh": "Complete SSH Session",
    "get-app-logs": "Get App Logs",
    "get-camera-logs": "Get Camera Logs",
    "logs": "Logs",
    "app-logs": "Recorder app logs",
    "camera-logs": "Camera system logs",
    "download": "Download",
    "logs-requested": "Log capture requested"
  },
  "annotations": {
    "showCoordinates": "Show coordinates"
  },
  "livestreamProvider": {
    "rtmp": "Generic - RTMP"
  },
  "yes": "Yes",
  "no": "No",
  "youtubeRemoved": "Video removed or Access to account revoked",
  "men": "Men",
  "women": "Women",
  "coed": "Coed",
  "search": "Search",
  "is-required": "is required",
  "is-invalid": "is invalid",
  "add-email": "Add email",
  "recipient-user-or-email": "Select a member or enter an email address",
  ":": ":",
  "none": "None",
  "all-feminin": "All",
  "error": "Error",
  "done": "Done",
  "password-reset-sent": "If an accont exists with this email address, a password reset email will be sent, use the received link to reset your password!",
  "password-reset-completed": "Password reset completed, you will be redirected to Login page!",
  "password-requirements": "Password must contain at least 8 characters, 1 upper case letter, and 1 special character",
  "password-reset-invalid-link": "Password reset link invalid, please try to submit the forgot password form again",
  "password-reset-expired": "Password reset link expired, please check your emails for a new link",
  "password-set-expired": "Password configuration link expired, please check your emails for a new link",
  "password-reset-completed-app": "Your password has been updated. Go back to the BoothPilot Replay app and sign in with your new password.",
  "password-reset-app-open": "Open Replay app",
  "password-reset-app-expired": "This password reset link has expired. Request a new one from the BoothPilot Replay app and try again.",
  "password-reset-app-invalid": "This password reset link is no longer valid — it may already have been used. Request a new one from the BoothPilot Replay app.",
  "auth-action-verifying": "Verifying your email...",
  "auth-action-verified-title": "Email verified",
  "auth-action-verified-body": "Your address is confirmed. If you were signing up in the BoothPilot Replay app, go back to it and tap \"I've verified my email\".",
  "auth-action-error-title": "We couldn't verify this link",
  "auth-action-expired": "This verification link has expired. Request a new one from the app and try again.",
  "auth-action-invalid": "This link is no longer valid — it may already have been used. If you have verified once, you are all set.",
  "does-not-match": "does not match",
  "errorMessages": {
    "title": "Error",
    "recording-not-found": "Recording not found.",
    "recording-not-ready": "Recording is not ready yet.",
    "recording-deleted": "This recording has been deleted because its retention period expired.",
    "team-not-found": "Invalid team link.",
    "recording-private-login-required": "This recording is private. You must be logged in to view it.",
    "recording-private-no-team": "This recording is private and is not associated with any team.",
    "recording-unlisted-no-team": "This recording is unlisted and is not associated with any team.",
    "recording-access-denied": "You do not have permission to view this recording.",
    "recording-unlisted-invalid-key": "The sharing link is invalid or expired.",
    "unkonwn-error": "An unexpected error occurred."
  },
  "team-recordings": {
    "title": "Team Recordings",
    "filter-days": {
      "7": "7 Days",
      "30": "30 Days",
      "90": "3 Months",
      "180": "6 Months",
      "all": "All Time"
    },
    "alerts": {
      "private-restricted": "Some recordings are hidden because they are private.",
      "private-restricted-ask-login-1": "Log in",
      "private-restricted-ask-login-2": "to view them.",
      "unlisted-restricted": "Some recordings are hidden because you do not have a valid sharing link.",
      "no-access": "No recordings available.",
      "empty-filter": "No recordings found for this time period."
    },
    "status": {
      "ready": "Ready",
      "deleted": "Deleted",
      "processing": "Processing"
    }
  },
  "team-list": {
    "title": "My Teams",
    "no-teams": "You are not a member of any team yet."
  }
}
